import * as React from "react";
import { AllIconNames } from "react-ui";

import { useCandyTheme } from "../../../../Internals/ThemeProvider/CandyTheme/UseCandyTheme";
import { Icon } from "../../../../Icons/Icon";

import { Root } from "./IconButton.styles";

export interface IconButtonProps {
    icon: AllIconNames;
    disabled?: boolean;
    onClick: React.MouseEventHandler;
}

export function IconButton(props: IconButtonProps): JSX.Element {
    const theme = useCandyTheme();

    const handleClick = (e: React.MouseEvent) => {
        e.stopPropagation();
        if (!props.disabled) {
            props.onClick(e);
        }
    };

    return (
        <Root onClick={handleClick} disabled={props.disabled}>
            <Icon name={props.icon} size={theme.typography.primary.fontSize.getNumber()} />
        </Root>
    );
}
